import React from 'react';

import Container from '@src/components/Shared/Container';
import SectionHeader from '@src/components/Shared/SectionHeader';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import RenderButtons from '@src/components/Shared/RenderButtons';

import { CallToActionPropTypes } from './CallToAction.types';

const CallToAction: React.FC<CallToActionPropTypes> = ({
  entryId = '',
  attr,
  title,
  bodyCopy,
  buttons,
  className,
  id,
}) => {
  return (
    <Container
      id={id}
      attr={attr}
      className='bg-background-tertiary max-w-[118.4rem]! rounded-[2.2rem] px-[2rem] py-[4rem] md:px-[3rem] md:py-[8rem]'
    >
      <SectionHeader
        entryId={entryId}
        title={title}
        titleClassName='w-full text-header-copy font-normal text-left sm:text-center leading-[2.2rem] font-extralight! text-[2.2rem] md:text-[2.8rem] lg:leading-[4.8rem] lg:text-[4.8rem] mb-[3.2rem]'
      />
      <RenderBodyCopy
        entryId={entryId}
        className={`${className} mx-auto mb-[2.2rem] max-w-[82rem] text-left font-extralight text-pretty sm:text-center md:mb-[2.4rem] lg:mb-[3.2rem] lg:[&>p]:text-[2.4rem]!`}
        bodyCopy={bodyCopy}
      />
      <RenderButtons className='justify-center' items={buttons} />
    </Container>
  );
};

export default CallToAction;
